import { z } from 'zod';

/**
 * Slug Validation for Tenants, Realms, and Businesses
 *
 * Allows: lowercase letters, numbers, hyphens
 * Forbids: # (reserved for workspace separator), spaces, special chars
 */
export const SLUG_REGEX = /^[a-z0-9-]+$/;

export const SLUG_MAX_LENGTH = 100;

/**
 * Tenant/Realm/Business slug validation schema
 *
 * Enforces lowercase alphanumeric with hyphens only.
 * The # character is reserved for workspace separation and is explicitly forbidden.
 */
export const slugSchema = z
  .string()
  .min(1, 'Slug is required')
  .max(SLUG_MAX_LENGTH, `Slug must be ${SLUG_MAX_LENGTH} characters or less`)
  .regex(SLUG_REGEX, 'Slug must contain only lowercase letters, numbers, and hyphens (no # allowed)');

/**
 * Name validation schema (more permissive than slug)
 *
 * Allows spaces and most characters, but forbids # to prevent confusion
 * with workspace separation in slugs/IDs.
 */
export const nameSchema = z
  .string()
  .min(1, 'Name is required')
  .max(255, 'Name must be 255 characters or less')
  .refine((name) => !name.includes('#'), 'Names cannot contain # (reserved for workspace separation)');
